import { Logo } from "./Logo";

export function SiteFooter() {
  return (
    <footer className="border-t border-border/60 bg-muted/30">
      <div className="container mx-auto flex flex-col items-center gap-6 px-4 py-10 sm:px-6 md:flex-row md:justify-between">
        <div className="flex flex-col items-center gap-3 md:items-start">
          <Logo />
          <p className="max-w-xs text-center text-sm text-muted-foreground md:text-left">
            Websites, crafted. Paid in Bitcoin Cash. Peer-to-peer, the way the
            web was meant to be.
          </p>
        </div>

        <div className="flex flex-col items-center gap-2 text-sm text-muted-foreground md:items-end">
          <div className="flex items-center gap-4">
            <a href="/#pricing" className="transition-colors hover:text-foreground">
              Pricing
            </a>
            <a href="/#faq" className="transition-colors hover:text-foreground">
              FAQ
            </a>
            <a href="/#start" className="transition-colors hover:text-foreground">
              Start a project
            </a>
          </div>
          <p>© {new Date().getFullYear()} BCH Launch. Built for the P2P web.</p>
          <a
            href="https://shakespeare.diy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-muted-foreground/70 transition-colors hover:text-foreground"
          >
            Vibed with Shakespeare
          </a>
        </div>
      </div>
    </footer>
  );
}
